import useTimezoneUtils from 'components/community/common/TimezoneSelector/useTimezoneUtils';
import { useMemo } from 'react';

export default function useTimezoneOffsetValues({ timezone }) {
    const { options } = useTimezoneUtils();

    const timeZones = useMemo(
        () =>
            (options || []).find(
                (op) =>
                    op?.value === timezone ||
                    (op?.alias || []).find((it) => it === timezone)
            )?.custom,
        [options, timezone]
    );
    const offset = useMemo(
        () =>
            (options || []).find(
                (op) =>
                    op?.value === timezone ||
                    (op?.alias || []).find((it) => it === timezone)
            )?.offset,
        [options, timezone]
    );
    const newTimeZone = useMemo(
        () =>
            (options || []).find((op) => op?.value === 'Asia/Shanghai')?.value,
        [options]
    );
    if (timezone === 'Hongkong') {
        return newTimeZone;
    }
    if (timeZones) {
        for (let i = 0; i < options.length; i++) {
            if (options[i].offset === offset) {
                return options[i].value;
            }
        }
    }
    return timezone;
}
